module.exports = __webpack_public_path__ + "img/idle.b2a77ca4.png";